import {
  ApiResponse,
  employeesBaseUrl,
  getData,
} from "@Services/constServices";

export const getEmployees_service = async (): Promise<ApiResponse> => {
  let url = `${employeesBaseUrl}/team-members`;
  const successMessage = "Empleados obtenidos correctamente";
  const errorMessage = "Error al obtener a los empleados";
  return getData(url, successMessage, errorMessage);
};
